import { usePromoCodeActions } from 'src/modules/promoCode/promoCodeStore';

export function useSetPromoCodes() {
    const setPromoCodes = usePromoCodeActions((actions) => actions.setPromoCodes);
    return setPromoCodes;
}
